import React from 'react';
import { Card } from "react-bootstrap";
import face_dorottya_szemere from "../../assets/img/face_dorottya_szemere.jpg";
import face_vivien_surman from "../../assets/img/face_vivien_surman.jpg";
import ShowMoreText from "react-show-more-text";
import proj_electric_scooters from "../../assets/img/proj_electric_scooters.png";

const D_Szemere_and_V_Surman_electric_scooters = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}
        <Card.Img variant="top" src={proj_electric_scooters} />
        <br />
        <Card.Body>
          <Card.Text class="d-flex justify-content-between card-text">
            {" "}

            <div>
            <img
              className="img2"
              src={face_dorottya_szemere}
              
            />{" "}
            <p className="text7">Dorottya Szemere</p>
            <br />
            <p className="text8">
              PhD student{" "}
            </p>
            </div>
            <div>
            <img
              className="img2"
              src={face_vivien_surman}
              
            />{" "}
            <p className="text7">Vivien Surman</p>
            <br />
            <p className="text8">
              Assistant Professor{" "}
            </p>
            </div>
            
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            <p className="text8">Department of Management and Business Economics, BME </p>
            </div>
            <div>
            Electric scooters have rapidly shaped urban landscapes, sparking varied perceptions 
            from green promise to safety concerns. Amidst this dichotomy, the literature on 
            electric scooters reflects a dynamic interplay of optimism and skepticism. Our project, 
            a bibliographic and network analysis, aims to comprehensively review recent papers on electric scooters.
            <br />
            <br />
            This project endeavors to conduct a systematic literature review on electric scooters, 
            aiming to provide a comprehensive analysis from three distinct perspectives. 1) 
            Technology Acceptance: Uncover insights into consumer perceptions and barriers 
            surrounding electric scooter adoption. 2) MaaS and Sharing Economy: Explore the 
            transformative role of electric scooters in Mobility as a Service and sharing economy 
            platforms. 3) Legal Models: Investigate regulatory landscapes influencing electric scooter deployment.    
            <br />
            <br />
            The project integrates co-authorship network analysis, citation network analysis, keyword 
            network analysis, and statistical analysis of bibliographical data. Leveraging academic 
            sources like Web of Knowledge and Scopus, our approach provides a nuanced understanding of 
            the literature's trajectory.
            <br />
            <br />
            We seek students intrigued by electric micromobility and enthusiastic about social network analysis.

            Related literature:{" "}

            <ul>
                <li>
                <a href="https://www.sciencedirect.com/science/article/pii/S2214367X22001478?via%3Dihub">
                Kriswardhana, W., & Esztergár-Kiss, D. (2023). A systematic literature review of Mobility as a Service: 
                Examining the socio-technical factors in MaaS adoption and bundling packages. Travel Behaviour and Society, 
                31, 232–243.</a>
                </li>
                <li>
                <a href="https://www.sciencedirect.com/science/article/pii/S2590198223001355?via%3Dihub">
                Mitropoulos, L., Stavropoulou, E., Tzouras, P., Karolemeas, C., & Kepaptsoglou, K. (2023). E-scooter micromobility 
                systems: Review of attributes and impacts. Transportation Research Interdisciplinary Perspectives, 21, 100888.</a>
                </li>
                <li>
                <a href="https://link.springer.com/chapter/10.1007/978-3-030-67044-3_1">
                Molontay, R., & Nagy, M. (2021). Twenty years of network science: A bibliographic and co-authorship network analysis. 
                In Big Data and Social Media Analytics: Trending Applications (pp. 1-24). Cham: Springer International Publishing.</a>
                </li>
                <li>
                <a href="https://ieeexplore.ieee.org/document/7809016">
                Xia, F., Wang, W., Bekele, T. M., & Liu, H. (2017). Big scholarly data: A survey. IEEE Transactions on Big Data, 3(1), 18-35.</a>
                </li>
            </ul>

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default D_Szemere_and_V_Surman_electric_scooters;